/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_UnknownInputs */

const th_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถตรวจสอบสถานะการแจ้งเตือนได้`)
};

const en_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not check whether notifications are on.`)
};

const ja_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知が有効かどうか確認できませんでした。`)
};

const zh_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法检查通知是否已打开。`)
};

const es_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha podido comprobar si las notificaciones están activadas.`)
};

const pt_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível verificar se as notificações estão ligadas.`)
};

const id_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak bisa memeriksa apakah notifikasi menyala.`)
};

const fr_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de vérifier si les notifications sont activées.`)
};

const tl_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi masuri kung nakabukas ang mga notipikasyon.`)
};

const vi_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không kiểm tra được thông báo có bật hay không.`)
};

const ko_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림이 켜져 있는지 확인할 수 없었습니다.`)
};

const de_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ließ sich nicht prüfen, ob Benachrichtigungen eingeschaltet sind.`)
};

const ru_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось проверить, включены ли уведомления.`)
};

const tr_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimlerin açık olup olmadığı denetlenemedi.`)
};

const it_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile verificare se le notifiche sono attive.`)
};

const pl_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się sprawdzić, czy powiadomienia są włączone.`)
};

const uk_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не вдалося перевірити, чи ввімкнено сповіщення.`)
};

const hi_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह जाँचा नहीं जा सका कि सूचनाएँ चालू हैं या नहीं।`)
};

const ar_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر التحقق من تفعيل الإشعارات.`)
};

const ms_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak dapat menyemak sama ada pemberitahuan dihidupkan.`)
};

const bn_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিজ্ঞপ্তি চালু আছে কি না পরীক্ষা করা যায়নি।`)
};

const zh_tw2_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法確認通知是否已開啟。`)
};

const zh_hk2_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法確認通知是否已開啟。`)
};

const ur_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`یہ جانچا نہ جا سکا کہ اطلاعات چالو ہیں یا نہیں۔`)
};

const fa_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بررسی نشد که اعلان‌ها روشن است یا نه.`)
};

const sw_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haikuweza kukaguliwa kama arifa zimewashwa.`)
};

const nl_push_unknown = /** @type {(inputs: Push_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er kon niet worden gecontroleerd of meldingen aanstaan.`)
};

/**
* | output |
* | --- |
* | "Could not check whether notifications are on." |
*
* @param {Push_UnknownInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_unknown = /** @type {((inputs?: Push_UnknownInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_UnknownInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_unknown(inputs)
	if (locale === "ja") return ja_push_unknown(inputs)
	if (locale === "zh") return zh_push_unknown(inputs)
	if (locale === "es") return es_push_unknown(inputs)
	if (locale === "pt") return pt_push_unknown(inputs)
	if (locale === "id") return id_push_unknown(inputs)
	if (locale === "fr") return fr_push_unknown(inputs)
	if (locale === "tl") return tl_push_unknown(inputs)
	if (locale === "vi") return vi_push_unknown(inputs)
	if (locale === "ko") return ko_push_unknown(inputs)
	if (locale === "de") return de_push_unknown(inputs)
	if (locale === "ru") return ru_push_unknown(inputs)
	if (locale === "tr") return tr_push_unknown(inputs)
	if (locale === "it") return it_push_unknown(inputs)
	if (locale === "pl") return pl_push_unknown(inputs)
	if (locale === "uk") return uk_push_unknown(inputs)
	if (locale === "hi") return hi_push_unknown(inputs)
	if (locale === "ar") return ar_push_unknown(inputs)
	if (locale === "ms") return ms_push_unknown(inputs)
	if (locale === "bn") return bn_push_unknown(inputs)
	if (locale === "zh-TW") return zh_tw2_push_unknown(inputs)
	if (locale === "zh-HK") return zh_hk2_push_unknown(inputs)
	if (locale === "ur") return ur_push_unknown(inputs)
	if (locale === "fa") return fa_push_unknown(inputs)
	if (locale === "sw") return sw_push_unknown(inputs)
	if (locale === "nl") return nl_push_unknown(inputs)
	return en_push_unknown(inputs)
});